"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { FileText, Download } from "lucide-react";
export default function TheAlmariaPhilosophy() {
  const {
    ref: sectionRef,
    isVisible: isSectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="222827" id="la-mia-storia" className="bg-background text-foreground py-20 lg:py-32 overflow-hidden" ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div ref={imageRef} className={`relative w-full max-w-md mx-auto lg:max-w-none transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            {}
            <div className="relative w-4/5 aspect-[3/4] lg:aspect-[4/5] z-10">
              <img src="https://in-oarfish-1.10web.cloud/wp-content/uploads/2026/05/ba-18.png" data-wvc-srcset="https://in-oarfish-1.10web.cloud/wp-content/uploads/2026/05/ba-18.png-wvc-srcset" data-wvc-sizes="https://in-oarfish-1.10web.cloud/wp-content/uploads/2026/05/ba-18.png-wvc-sizes" alt="Massimiliano Borelli Candidato Sindaco" className="w-full h-full object-cover rounded-lg shadow-xl" loading="lazy" />
              
              {}
              <div className="absolute -top-6 -left-6 z-30">
                <Badge variant="secondary" className="px-4 py-2 text-sm font-default font-semibold tracking-wider uppercase shadow-md rounded-lg bg-secondary text-secondary-foreground">albano conta</Badge>
              </div>
            </div>

            {}
            <div className="absolute -bottom-8 -right-4 w-2/3 aspect-square z-20">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659171/img/albano_piazza_storica.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659171/img/albano_piazza_storica.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659171/img/albano_piazza_storica.png-wvc-sizes" alt="Veduta di Albano Laziale" className="w-full h-full object-cover rounded-lg border-8 border-background shadow-2xl" loading="lazy" />
            </div>
            
            {}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-primary/5 rounded-lg blur-3xl -z-10"></div>
          </div>

          {}
          <div ref={textRef} className={`flex flex-col gap-8 transition-all duration-1000 delay-300 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="space-y-6">
              <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-primary leading-tight">
                La Mia <br className="hidden lg:block" />
                <span className="text-primary">Storia</span>
              </h2>
              
              <div className="w-16 h-1 bg-secondary rounded-lg"></div>
              <p className="text-primary font-semibold tracking-wide uppercase text-sm">Massimiliano Borelli Candidato Sindaco</p>
            </div>

            <div className="space-y-6 text-lg text-foreground/80 leading-relaxed font-default">
              <p className="text-xl font-medium text-foreground first-letter:text-5xl first-letter:font-bold first-letter:text-primary first-letter:mr-3 first-letter:float-left">
                Crescere ad Albano significa respirare la storia di una comunità che non si arrende mai. Il mio percorso politico nasce dall'ascolto quotidiano dei cittadini e dalla volontà di trasformare le promesse in fatti concreti per il nostro territorio.
              </p>
              <p>
                In questi anni di amministrazione, ho imparato che la competenza e la presenza costante sono gli unici strumenti per governare con responsabilità. La mia visione per Albano, Pavona e Cecchina mette al centro il decoro urbano, la sicurezza e uno sviluppo sostenibile che valorizzi le nostre radici guardando al futuro.
              </p>
              
              <div className="flex flex-wrap gap-4 pt-4">
                <Button asChild variant="default" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg shadow-md px-6 py-6 h-auto">
                  <Link to="https://borellisindaco.it/wp-content/uploads/2026/05/cv_europeo_Borelli-aggiornato.pdf" newTab download className="flex items-center gap-2">
                    <FileText className="w-5 h-5" />
                    <span>Curriculum</span>
                    <Download className="w-4 h-4 ml-1 opacity-70" />
                  </Link>
                </Button>
                <Button asChild variant="outline" className="border-primary text-primary hover:bg-primary/5 rounded-lg shadow-md px-6 py-6 h-auto">
                  <Link to="https://borellisindaco.it/wp-content/uploads/2026/05/borelli-3.pdf" newTab download className="flex items-center gap-2">
                    <FileText className="w-5 h-5" />
                    <span>Casellario</span>
                    <Download className="w-4 h-4 ml-1 opacity-70" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}